
import Vue from "vue";
import {OmniSearch, omniSearchApi, SearchType} from "@/api/omnisearch";
import {flameApi} from "@/api/flame";
import {encounterApi} from "@/api/encounter";
import {emailApi} from "@/api/email";
import {attachmentApi} from "@/api/attachments";
import {projectApi} from "@/api/projects";

let timedOutFunction: any;

export default Vue.extend({
  name: "OmniSearchBox",

  data: () => ({
    omniSearch: "",
    omniSearchItems: [] as OmniSearch[],
    searching: false,
    selectedOmniSearch: null,
  }),

  watch: {
    omniSearch(val) {
      if (!val || val.length === 0) {
        return;
      }
      this.clearEntries();
      this.searching = true;
      this.fetchEntriesDebounced();
      if (timedOutFunction) {
        clearTimeout(timedOutFunction);
      }
      timedOutFunction = setTimeout(() => {
        val && val !== this.selectedOmniSearch && this.startOmniSearch();
      }, 1500);
    },
    async selectedOmniSearch(val) {
      if (!val || val.length === 0) {
        return;
      }
      await this.navigateSelectedOmniSearch(val);
    },
  },
  methods: {
    clearEntries() {
      this.omniSearchItems = [];
    },
    fetchEntriesDebounced() {
      clearTimeout(timedOutFunction);
      timedOutFunction = setTimeout(() => {
        this.startOmniSearch();
      }, 1500);
    },
    async navigateSelectedOmniSearch(omniSearch: OmniSearch) {
      if (omniSearch.searchType === SearchType.CONTACT) {
        await this.$router.push(`/contacts/${omniSearch.upstreamRef}`);
      }

      if (omniSearch.searchType === SearchType.FLAME) {
        const flame = await flameApi.getById(omniSearch.upstreamRef);
        if (flame) {
          await this.$router.push(`/flames/${flame.id}/${flame.blackBoardRef}`);
        }
      }

      if (omniSearch.searchType === SearchType.PROJECT) {
        const project = await projectApi.getById(omniSearch.upstreamRef);
        if (project) {
          await this.$router.push(`/projects/${project.id}/${project.blackBoardRef}`);
        }
      }

      if (omniSearch.searchType === SearchType.ENCOUNTER) {
        const encounter = await encounterApi.getById(omniSearch.upstreamRef);
        if (encounter) {
          await this.$router.push(
              `/contacts/${encounter.contactRef}/encounters/${encounter.id}`
          );
        }
      }

      if (omniSearch.searchType === SearchType.EMAIL) {
        const email = await emailApi.getMessage(omniSearch.upstreamRef);
        if (email) {
          const assigneeRef = email.assigneeRef ? email.assigneeRef : "-2";
          await this.$router.push(`/emails/${assigneeRef}/${email.id}`);
        }
      }

      if (omniSearch.searchType === SearchType.CONTACT_ATTACHMENT) {
        const attachment = await attachmentApi.getById(omniSearch.upstreamRef);
        if (attachment) {
          await this.$router.push(
              `/contacts/${attachment.contactRef}/attachments/${attachment.id}`
          );
        }
      }
      this.omniSearch = "";
      this.omniSearchItems = [];
    },
    mapToIcon(omniSearch: OmniSearch) {
      switch (omniSearch.searchType) {
        case SearchType.CONTACT:
          return "mdi-account";
        case SearchType.FLAME:
          return "mdi-fire";
        case SearchType.PROJECT:
          return "mdi-lightbulb-on";
        case SearchType.ENCOUNTER:
          return "mdi-timeline";
        case SearchType.EMAIL:
          return "mdi-email";
        case SearchType.CONTACT_ATTACHMENT:
          return "mdi-attachment";
        default:
          return "mdi-crosshair-question";
      }
    },
    async startOmniSearch() {
      const result = await omniSearchApi.search(this.omniSearch);
      if (result) {
        this.omniSearchItems = result;
      }
      this.searching = false;
    },
  },
});
